import AnimateBottom from "components/Animations/AnimateBottom";
import { useTranslation } from "react-i18next";
import Stats from "./Stats";
import SecurityTeams from "./SecurityTeams";
import SmartcomplyDrive from "./SmartcomplyDrive";
import { offersEn, offersFr } from "./utils";

export default function AboutUs() {
  const { t } = useTranslation("about");
  const language = localStorage.getItem("selectedLanguage");

  const alphabets = "abcdefghij";
  const offers = language?.includes("fr") ? offersFr : offersEn;
  return (
    <>
      <div className=" bg-[#E7F3FF]">
        <div className="px-14 pt-24 max-md:px-8 max-[520px]:px-4 max-lg:py-16">
          <AnimateBottom delay={0.4}>
            <div className="flex gap-6 justify-between items-start flex-col xl:flex-row font-lexend">
              <div className="xl:w-[50%] space-y-5">
                <p className="text-black text-2xl font-light">
                  {t("hero.minTitle")}
                </p>

                <h3 className="text-black font-medium text-[36px] md:text-[44px] w-full xl:w-[80%]">
                  {t("section1.title")}
                </h3>
              </div>
              <div className="space-y-10 xl:w-[50%]">
                <p className="text-[20px]  text-[#00000066] font-light font-lexend md:w-[95%]">
                  {t("section1.subtitle1")}{" "}
                </p>
                <p className="text-[20px]  text-[#00000066] font-light font-lexend md:w-[95%]">
                  {t("section1.subtitle4")}
                </p>
              </div>
            </div>
          </AnimateBottom>
        </div>

        <section className="px-14 md:py-16 max-md:px-8 max-[520px]:px-4 max-md:pb-10 bg-transparent font-lexend">
          <Stats />
        </section>
      </div>
      <SmartcomplyDrive />
      <section className=" px-14 py-20 max-md:px-8 max-[520px]:px-4 max-lg:py-16 w-full bg-[#E7F3FF]">
        <div className="mb-6 max-md:mb-4 flex items-end justify-between w-full max-md:flex-col-reverse max-md:gap-8 max-md:justify-start max-md:items-start">
          <h3 className="text-[#18214D] font-semibold text-[36px] md:text-[44px] md:text-left mb-4 md:w-[40%] xl:w-[27%] text-lexend text-center !leading-[62px]">
            {t("offers.title")}
          </h3>
        </div>
        <div className="text-sm font-lexend grid grid-cols-4 gap-2 items-center h-auto flex-wrap w-full max-md:grid-cols-2 max-[520px]:grid-cols-1 mb-2">
          {offers.slice(0, 4).map((offer, key) => (
            <div
              key={offer.slice(0, 5) + key}
              className="w-full h-full ease-in-out duration-[500ms] flex items-center justify-center max-[520px]:justify-start max-md:min-h-[60px] text-left p-3 text-black border border-black"
            >
              <p>{t(`offers.${alphabets[key]}`)}</p>
            </div>
          ))}
        </div>
        <div
          style={{ gridTemplateColumns: "28% 20% 20% 30%" }}
          className="font-lexend grid gap-2 items-center h-auto flex-wrap w-full max-lg:!grid-cols-2 max-[520px]:!grid-cols-1 mb-2"
        >
          {offers.slice(4, 8).map((offer, key) => (
            <div
              key={offer.slice(0, 5) + key}
              className={`w-full h-full ease-in-out duration-[500ms] flex items-center justify-center max-[520px]:justify-start max-md:min-h-[60px] text-left p-3 text-black border border-black`}
            >
              <p>{t(`offers.${alphabets[key + 4]}`)}</p>
            </div>
          ))}
        </div>
        <div className="font-lexend grid grid-cols-2 gap-2 items-center h-auto flex-wrap w-full max-md:grid-cols-2 max-[520px]:grid-cols-1">
          {offers.slice(8).map((offer, key) => (
            <div
              key={offer.slice(0, 5) + key}
              className="w-full h-full ease-in-out duration-[500ms] flex items-center justify-center max-[520px]:justify-start max-md:min-h-[60px] text-left p-3 text-black border border-black"
            >
              <p>{t(`offers.${alphabets[key + 8]}`)}</p>
            </div>
          ))}
        </div>
      </section>
      <div className="w-full">
        <SecurityTeams />
      </div>
    </>
  );
}
